export const BannerDefaultDuration = 30;

export const BannerEvents = {
    BannerLoaded: "bannerLoaded",
    BannerError: "bannerError"
} as const;

export const BannerQaCommentedOnBy = {
    Me: "ME",
    Any: "ANY",
    None: "NONE"
} as const;

export const BannerQaStatus = {
    Draft: "IN_DRAFT",
    InReview: "IN_QA",
    Approved: "QA_APPROVED",
    Rejected: "QA_REJECTED"
} as const;

export const BannerQaUserStatus = {
    None: "NONE",
    Approved: "QA_APPROVED",
    Rejected: "QA_REJECTED",
    INone: "INONE",
    IApproved: "IQA_APPROVED",
    IRejected: "IQA_REJECTED"
} as const;

export const UserStatusUser = {
    Me: "ME",
    Any: "ANY"
} as const;

export const BannerQaUserStatusLabelFilterMap = {
    [BannerQaUserStatus.INone]: { user: UserStatusUser.Me, status: BannerQaUserStatus.None },
    [BannerQaUserStatus.IApproved]: { user: UserStatusUser.Me, status: BannerQaUserStatus.Approved },
    [BannerQaUserStatus.IRejected]: { user: UserStatusUser.Me, status: BannerQaUserStatus.Rejected },
    [BannerQaUserStatus.None]: { user: UserStatusUser.Any, status: BannerQaUserStatus.None },
    [BannerQaUserStatus.Approved]: { user: UserStatusUser.Any, status: BannerQaUserStatus.Approved },
    [BannerQaUserStatus.Rejected]: { user: UserStatusUser.Any, status: BannerQaUserStatus.Rejected }
};
